<template>
  <post :post="postData"></post>
</template>

<script>
import Post from '@/components/Post'
import postData from '../mock/PrivacyPolicy.json'

export default {
  name: 'Privacy',
  components: {
    Post
  },
  data: () => ({
    postData: postData
  })
}
</script>

<style scoped>

</style>
